module.exports = __webpack_public_path__ + "img/2012-12-14 18.22.07.43759674.jpg";